import React from 'react';
import { useRouter } from 'next/router';
import AllProjectsPageTemplate from './template';
import { Project } from '../../../types/schema';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { additionalLinkTags, breadcrumbTitle, SEO } from '../../../utils/SEO';

type AllProjectsPageComponentProps = {
  mainProjects: Project[];
  sideProjects: Project[];
  metaTitle: string;
  metaDescription: string;
  metaImage: string;
  hideAppMastersTitle: boolean;
  pageTitle?: string;
  language: string;
  bannerImg: string;
};

const AllProjectsPageComponent: React.FC<AllProjectsPageComponentProps> = ({
  mainProjects,
  sideProjects,
  pageTitle,
  metaDescription,
  metaTitle,
  hideAppMastersTitle,
  metaImage,
  language,
  bannerImg,
}) => {
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000/';
  const router = useRouter();
  const isEn = language === 'en';
  const description = isEn
    ? 'Web and Mobile projects developed to clients using React, Node, Google Cloud Platform and other technologies.'
    : 'Projetos web e mobile desenvolvidos para cliente utilizando React, Node, Google Cloud Platform entre outras tecnologias';

  const itemListElements = [
    {
      position: 1,
      name: 'App Masters',
      item: `${siteUrl}${router.locale}`,
    },
    {
      position: 2,
      name: breadcrumbTitle(
        (metaTitle || pageTitle || (isEn ? 'Projects' : 'Projetos')) as string,
        isEn,
        hideAppMastersTitle,
      ),
      item: `${siteUrl}${router.locale}/${isEn ? 'projects' : 'projetos'}`,
    },
  ];

  return (
    <>
      <NextSeo
        {...SEO({
          pathname: router.asPath,
          locale: router.locale as string,
          title: (metaTitle || pageTitle) as string,
          defaultTitle: {
            enTitle: 'Projects',
            ptTitle: 'Projetos',
          },
          description: (metaDescription || description) as string,
          image: metaImage as string,
          hideAppMastersTitle: hideAppMastersTitle as boolean,
        })}
        additionalLinkTags={additionalLinkTags(['projetos', 'projects'])}
      />
      <BreadcrumbJsonLd itemListElements={itemListElements} />
      <AllProjectsPageTemplate
        mainProjects={mainProjects}
        sideProjects={sideProjects}
        language={language}
        bannerImg={bannerImg}
      />
    </>
  );
};

export default AllProjectsPageComponent;
